module.exports = __webpack_public_path__ + "static/media/28-10.71b74e3e.mp3";